import React from "react";
import ISOServiceIndia9001 from "../../../components/ISO Certificates/ISO Common/ISOServiceIndia9001";
import ISOHeader13485 from "../../../components/ISO Certificates/ISO 13485-2016/ISOHeader13485";
import ISOContent13485 from "../../../components/ISO Certificates/ISO 13485-2016/ISOHeader13485";
import ISOSpecification13485 from "../../../components/ISO Certificates/ISO 13485-2016/ISOSpecification13485";

const ISO134852016 = () => {
  return (
    <div>
      {/* <ISOHeader13485 /> */}
      <ISOContent13485 />
      <ISOServiceIndia9001 />
      <ISOSpecification13485 />
    </div>
  );
};

export default ISO134852016;
